import {FC, ReactNode} from 'react';
import clsx from 'clsx';

import s from './styles.module.scss';

export enum PlateType {
  error = 'error',
  success = 'success',
  info = 'info',
  transparent = 'transparent',
}

interface PlateProps {
  type: PlateType;
  children: ReactNode;
  className?: string;
}

const Plate: FC<PlateProps> = ({type, children, className}) => (
  <div className={clsx(s.plate, s[`plate--${type}`], className)}>{children}</div>
);

export default Plate;
